import { AsyncBoundary, Col, DataGrid } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { type PeriodBalanceRecord } from '../../_graphql/queryInventoryPeriodBalances';
import * as state from '../../_state/periodDetail.state';
import { useTranslations } from '../../i18n/useTranslations';

import { usePeriodBalanceColumns } from './usePeriodBalanceColumns';

export const PeriodBalanceTable = () => {
  const t = useTranslations();

  const { data, isFetching, loadingState, error } = useAtomValue(
    state.$remotePeriodBalances,
  );

  const columns = usePeriodBalanceColumns();

  const balances = data ?? [];

  return (
    <Col gap2 className="@PeriodBalanceTable">
      <h3 className="text-base font-semibold">
        {t.periodsListView.detail.balanceSnapshot}
      </h3>
      <AsyncBoundary
        error={error}
        loading={loadingState.isInitialLoading || isFetching}
      >
        <DataGrid<PeriodBalanceRecord>
          isContained
          columns={columns}
          dataSource={balances}
          rowKey="id"
          aria-label={t.periodsListView.detail.balanceTable.aria}
          selectionMode="none"
          fullWidth
          emptyPanelProps={{
            title: t.periodsListView.detail.balanceTable.empty,
            description: '',
            centered: true,
          }}
        />
      </AsyncBoundary>
    </Col>
  );
};
